export default function () {
  return {}
}
